import type { PartialMessages } from "../messages";

export const ja: PartialMessages = {
  "status.syncing": "同期中",
  "status.connecting": "接続中",
  "status.full": "満員",
  "status.closed": "切断",
  "toast.connecting": "接続中…",
  "toast.reconnecting": "切断されました。再接続しています…",
  "toast.retrying": "しばらくして自動で再試行します",
  "toast.busy": "いま混み合っています",
  "notice.mapChanged": "{name} がマップを切り替えました",

  "hint.place": "クリックで設置 / そのままドラッグして向きを決める（Esc で中止）",

  "kind.objective": "目的地",
  "kind.rally": "集合",
  "kind.enemy": "敵",
  "kind.loot": "戦利品",
  "kind.extract": "脱出",
  "kind.danger": "危険",
  "kind.self": "自分",
  "kind.ping": "ここ！",
  "hint.objective": "どこへ向かうか",
  "hint.rally": "合流地点",
  "hint.enemy": "見た方向を向けて置く",
  "hint.loot": "レアコンテナ・死体",
  "hint.extract": "使う脱出口",
  "hint.danger": "地雷・スナイパー・開けた場所",
  "hint.self": "自分の現在地。置き直すと前のものは消えます",
  "hint.ping": "25秒で自動的に消える一時マーカー",

  "tool.clearMine": "自分の分を消去",
  "tool.clearMineHint": "自分が置いたピンを全部消します",

  "sidebar.map": "マップ（全員に反映）",
  "sidebar.styleSvg": "イラスト",
  "sidebar.styleTile": "航空写真",
  "sidebar.floors": "階層（自分の表示だけ変わります）",
  "sidebar.groundFloor": "地上・基準",
  "sidebar.floorNote": "別の階層に置かれたピンは薄く表示されます。",
  "sidebar.floorOtherStyle": "* 押すと地図の表示が{style}に切り替わります。",
  "sidebar.members": "参加者 {count}人",
  "sidebar.roomLink": "この地図のリンク",
  "sidebar.roomLinkCopy": "リンクをコピー",
  "sidebar.roomLinkCopied": "コピーしました",
  "sidebar.roomLinkNote": "このリンクを開いた人は、Discord でログインすると同じ地図に来られます。",
  "sidebar.hide": "パネルを隠す",
  "sidebar.show": "パネルを表示",
  "spawns.show": "湧きの目安を表示",
  "spawns.note": "PMC のレイド開始位置のおおよその目安です。ゲーム側が広い範囲に散らすので、正確な位置ではありません",
  "spawns.unnamed": "入口 {n}",
  "tool.eraser": "消しゴム",
  "hint.eraser": "ピンや線をなぞって消します",
  "hint.erasing": "押す・なぞるとピンも線も消えます。Esc でやめます",
  "tool.penColor": "線の色",
  "tool.penColorMine": "線の色（自分の色）",
  "list.title": "ピンと線の一覧",
  "list.empty": "このマップにはまだ何もありません",
  "list.show": "地図で見る",
  "list.remove": "削除",
  "sidebar.you": "あなた",
  "sidebar.guest": "ゲスト",
  "sidebar.clearAll": "全員のピンを消去",
  "sidebar.openWindow": "別ウィンドウで開く（自分用）",
  "sidebar.invite": "人を招待する",
  "sidebar.help": "使い方",
  "sidebar.feedback": "要望・不具合を送る",
  "sidebar.mapData": "地図データ",
  "sidebar.license": "ライセンス",
  "sidebar.licenseNote": "非営利利用に限ります",
  "sidebar.room": "ルーム",

  "extracts.show": "脱出口を表示",
  "extracts.none": "このマップの脱出口データはありません",
  "extracts.unnamed": "名称不明の脱出口",
  "extracts.pmc": "PMC",
  "extracts.scav": "スカブ",
  "extracts.shared": "共通",
  "extracts.coop": "共同",
  "extracts.transit": "トランジット",

  "pin.facing": "向き",
  "pin.floor": "階層",
  "pin.map": "マップ",
  "pin.noFacing": "向きなし",
  "pin.facingValue": "{compass}向き（{degrees}°）",
  "pin.notePlaceholder": "メモを書く（例: 3階の窓）",
  "pin.removeMine": "このピンを削除",
  "pin.removeOther": "他の人のピンを削除",
  "pin.close": "閉じる",
  "compass.n": "北",
  "compass.ne": "北東",
  "compass.e": "東",
  "compass.se": "南東",
  "compass.s": "南",
  "compass.sw": "南西",
  "compass.w": "西",
  "compass.nw": "北西",

  "kind.draw": "ペン",
  "hint.draw": "地図に線を描く",
  "hint.drawing": "ドラッグで線を描きます。色は右のボタンで選べます。Ctrl+Z で直前の1本を取り消し、消しゴムでなぞって消します。",
  "handoff.title": "別ウィンドウで開く",
  "handoff.lede":
    "自分用のリンクです。同じ部屋をブラウザで開くので、Discord 側では画面共有を見たまま、地図をサブモニタやタブレットに置けます。",
  "handoff.open": "このパソコンのブラウザで開く",
  "handoff.or": "別の端末で開くなら",
  "handoff.codeHint": "その端末で {host}/j/ に続けて上のコードを入力しても開けます。",
  "handoff.copy": "リンクをコピー",
  "handoff.copied": "コピーしました",
  "handoff.copyFailed": "上の欄を選択しました — Ctrl+C を押してください",
  "handoff.expiry":
    "このリンクを開けるのは自分だけです。有効期限はあと {time}。" +
    "一度開いた端末なら、あとから開き直せます。",
  "handoff.warn":
    "他の人に渡しても開けません。人を呼ぶときは「人を招待する」からリンクを作ってください。",
  "handoff.creating": "リンクを作成しています…",
  "handoff.failed": "リンクを作れませんでした",

  "invite.title": "人を招待する",
  "invite.lede":
    "ボイスチャンネルにいない人を、この地図に呼べます。リンクを開いた人は名前を入れて参加し、ピンを置けるようになります。",
  "invite.copy": "リンクをコピー",
  "invite.warn":
    "このリンクを知っている人は誰でも参加できます。公開の場に貼らないでください。",
  "invite.budget": "あと {left} 人まで・{time}で失効（使用済み {used}/{max}）。",
  "invite.revoke": "このリンクを今すぐ無効にする",
  "invite.revoked": "リンクを無効にしました。",
  "invite.creating": "リンクを作成しています…",
  "invite.failed": "リンクを作れませんでした",
  "invite.revokeFailed": "無効にできませんでした",

  "join.title": "地図に参加する",
  "join.lede":
    "招待されたレイドの地図に入ります。表示する名前を決めてください。置いたピンにはこの名前が出ます。",
  "join.name": "名前",
  "join.go": "参加する",
  "join.joining": "参加しています…",
  "join.failed": "参加できませんでした",

  "feedback.title": "作者に送る",
  "feedback.request": "要望",
  "feedback.bug": "不具合",
  "feedback.other": "その他",
  "feedback.requestHint": "こうなったら嬉しい",
  "feedback.bugHint": "おかしい・動かない",
  "feedback.otherHint": "感想でもなんでも",
  "feedback.placeholder":
    "例: ピンに矢印だけでなく線を引きたい / Streetsで地下の階層が切り替わらない",
  "feedback.note": "Discord の表示名と ID が一緒に送られます。返信が必要な場合の連絡先になります。",
  "feedback.send": "送る",
  "feedback.sending": "送信中…",
  "feedback.sent": "送信しました。ありがとうございます。",
  "feedback.failed": "送信できませんでした",

  "time.minutes": "約{n}分",
  "time.hoursMinutes": "約{h}時間{m}分",

  "error.roomFull": "この部屋は満員です",
  "error.tooManyWindows": "この部屋を開きすぎです。ほかのウィンドウを閉じてください",
  "error.serverFull": "サーバーが混み合っています",
  "error.session": "セッションが無効です。開き直してください",
  "error.handoffSpent":
    "このリンクはもう開かれています。作った人専用・1回きりのリンクです。" +
    "同じ部屋に入るには、その人に地図の「人を招待する」から招待リンクをもらってください。",
  "error.handoffExpired":
    "このリンクは有効期限（30分）が切れています。" +
    "地図の「別ウィンドウで開く」からもう一度作ってください。",
  "error.handoffUnknown":
    "このリンクは使えません。リンクが途中で切れていないか確かめるか、" +
    "地図の「別ウィンドウで開く」からもう一度作ってください。",
  "error.inviteSpent":
    "この招待リンクは使えなくなっています。部屋の人に新しいリンクをもらってください",
  "error.inviteNotOwner": "このリンクを作った人だけが無効にできます",
  "error.noRoom": "部屋が指定されていません",
  "error.needName": "名前を入力してください",
  "error.tooShort": "もう少し詳しく書いてください",
  "error.tooLong": "長すぎます",
  "error.badKind": "種別が不正です",
  "error.rateLimited": "送りすぎです。10分ほど待ってからお願いします",
  "error.busy": "混み合っています。少し待ってから送ってください",
  "error.sendFailed": "送信できませんでした。時間をおいて試してください",
  "error.feedbackClosed": "いまは受付を停止しています",
  "error.sessionGone": "元のセッションが終了しています。アクティビティから開き直してください",

  "landing.tagline1": "タルコフのマップを、",
  "landing.tagline2": "Discord の通話中にみんなで見ながら説明できます。",
  "landing.install": "Discord に追加する",
  "landing.installNote": "無料。ボイスチャンネルのロケットのアイコンから起動します。",
  "landing.browser": "ブラウザで開く",
  "landing.browserNote":
    "Discord でログインしてすぐ地図が開きます。出てきた URL を渡せば、通話に入っていない人も同じ地図に来られます。",
  "landing.body":
    "通話にいる全員の画面に同じ地図が出ます。クリックでピンを置き、そのままドラッグすると向きの矢印が付くので、場所だけでなく「どっちを向いて進むか」まで示せます。",
  "landing.point1": "同じ通話にいるだけで同じ地図に入ります",
  "landing.point2": "全13マップ。イラストと航空写真、フロアの切り替え",
  "landing.point3": "置いたピンは残るので、あとから見返せます",
  "landing.point4": "通話にいない人も、招待リンクを渡せば参加できます",
  "landing.footNote":
    "ゲームには一切触れません。ファイルもメモリも読まず、ゲーム画面にも何も出しません。ピンはすべて人が手で置いたものです。",
  "landing.footCredit":
    "個人が趣味で作って、無料で動かしています。地図データは {tarkovdev}（CC BY-NC-SA 4.0）を使っています。Escape from Tarkov は Battlestate Games Limited の製品で、これは同社とは関係のない非公式なファン制作物です。",
  "landing.updates": "更新履歴",
  "landing.allUpdates": "すべての更新",

  "crash.title": "問題が発生しました",
  "crash.body":
    "地図を表示できませんでした。内容は自動で作者に報告されています。再読み込みで直ることがほとんどです。",
  "crash.code": "照合番号",
  "crash.reload": "再読み込み",
  "trace.label": "ID",

  "boot.connecting": "Discord に接続しています…",
  "boot.failedTitle": "起動できませんでした",
  "boot.failedUnknown": "Discord から応答がありませんでした。アクティビティを一度閉じて開き直してください",
};
